/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Search_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search by name..." |
*
* @param {League_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_search_placeholder = /** @type {((inputs?: League_Search_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Search_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher par nom...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar por nombre...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Buscar por nome...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca per nome...")
	return /** @type {LocalizedString} */ ("Search by name...")
});